import React from "react";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import Select from "react-select";
import { useKarantina } from "./useKarantina";
import EditLogo from "../../Assets/editLogo.png";
import CloseLogo from "../../Assets/close_icon.png";
import DeleteIcon from "../../Assets/delete_icon.png";
import moment from "moment";
import { filterMonthConstant, filterYearConstant } from "../../util/formatDate";
import "./Karantina.css";
import * as XLSX from "xlsx";
import { hasRole } from "../../util/utilFunction";

const Karantina = () => {
  const {
    dataUser,
    subMenu,
    setSubMenu,
    asalBarang,
    customer,
    noMesin,
    filterProduk,
    setFilterProduk,
    popUpEdit,
    setPopUpEdit,
    popUpPengerjaan,
    setPopUpPengerjaan,
    pelanggan,
    setPelanggan,
    tanggalProduksi,
    setTanggalproduksi,
    bagian,
    setBagian,
    shift,
    setShift,
    operator,
    setOperator,
    mesin,
    setMesin,
    isiPerKemasan,
    setIsiPerKemasan,
    jumlahKemasan,
    setJumlahKemasan,
    jumlahTotal,
    setJumlahTotal,
    keterangan,
    setKeterangan,
    listProduk,
    produkPick,
    setProdukPick,
    handleKirim,
    popUpKirim,
    errPopUp,
    setErrPopUp,
    popUpSuccess,
    setPopUpSuccess,
    handleKirimPengerjaan,
    handlePickNota,
    jumlahPengerjaan,
    jumlahNG,
    setJumlahPengerjaan,
    setJumlahNG,
    listRiwayatPengerjaan,
    filterMonth,
    setFilterMonth,
    filterBagian,
    setFilterBagian,
    aggregateSortiran,
    produkPopUp,
    handleClosePopUp,
    editPengerjaan,
    setEditPengerjaan,
    editNG,
    setEditNG,
    pickEdit,
    handleKirimEdit,
    isEditNota,
    setIsEditNota,
    jumlahTotalEdit,
    setJumlahTotalEdit,
    handleKirimEditNota,
    jumlahKemasanEdit,
    setJumlahKemasanEdit,
    popUpDelete,
    setPopUpDelete,
    handleDeletePengerjaan,
    pickEditDelete,
    filterYear,
    setFilterYear,
    jumlahRework,
    setJumlahRework,
    editJumlahRework,
    setEditJumlahRework,
  } = useKarantina();

  const formatDot = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const formatDateNota = (date) => {
    const newDate = new Date(date);
    return moment(newDate).format("DD/MM/YYYY");
  };

  let dataMerge = [];
  let listFilterProduk = [];

  listRiwayatPengerjaan &&
    listRiwayatPengerjaan.forEach((e) => {
      if (!listFilterProduk.some((ele) => ele === e.produkPick)) {
        listFilterProduk.push(e.produkPick);
      }

      if (e.produkPick === filterProduk) {
        e &&
          e.dataPengerjaan.forEach((data) => {
            dataMerge.push({
              tanggalNota: e.tanggalNota,
              time: data.time,
              operator: data.operator,
              produkPick: e.produkPick,
              jumlahPengerjaan: data.jumlahPengerjaan,
              jumlahNG: data.jumlahNG,
              jumlahRework: data.jumlahRework,
              bagian: e.bagian,
              id: data.id,
              idNota: e.id,
            });
          });
      } else if (!filterProduk) {
        e &&
          e.dataPengerjaan.forEach((data) => {
            dataMerge.push({
              tanggalNota: e.tanggalNota,
              time: data.time,
              operator: data.operator,
              produkPick: e.produkPick,
              jumlahPengerjaan: data.jumlahPengerjaan,
              jumlahNG: data.jumlahNG,
              jumlahRework: data.jumlahRework,
              bagian: e.bagian,
              id: data.id,
              idNota: e.id,
            });
          });
      }
    });

  const exportRiwayatPengerjaan = async () => {
    const formatDot = (value) => {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const filteredDataExcel =
      dataMerge &&
      dataMerge.map((obj) => {
        const bagian = obj.bagian ? obj.bagian : "";
        const jumlahNG = obj.jumlahNG ? obj.jumlahNG : 0;
        const jumlahPengerjaan = obj.jumlahPengerjaan
          ? obj.jumlahPengerjaan
          : 0;
        const jumlahRework = obj.jumlahRework ? obj.jumlahRework : 0;
        const validateNama = obj.operator ? obj.operator : "";
        const produkPick = obj.produkPick ? obj.produkPick : "";
        const tanggalNota = obj.tanggalNota ? obj.tanggalNota : "";
        const time = obj.time ? obj.time : "";

        return {
          NOTA: formatDateNota(tanggalNota),
          PENGERJAAN: formatDateNota(time),
          OPERATOR: validateNama,
          PRODUK: produkPick,
          "PENGERJAAN(Pcs)": formatDot(jumlahPengerjaan),
          "NG(PCS)": formatDot(jumlahNG),
          "REWORK(PCS)": formatDot(jumlahRework),
          BAGIAN: bagian,
        };
      });

    const workSheet = XLSX.utils.json_to_sheet(
      filteredDataExcel && filteredDataExcel
    );

    workSheet["!cols"] = [
      { wch: 11 },
      { wch: 11 },
      { wch: 30 },
      { wch: 40 },
      { wch: 15 },
      { wch: 7 },
      { wch: 8 },
    ];

    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Laporan");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Laporan Karantina.xlsx`);
  };

  const sortDataRiwayat = dataMerge && dataMerge.reverse();

  aggregateSortiran &&
    aggregateSortiran.sort(function (a, b) {
      if (a.sisa !== 0 && new Date(a.time) > b.sisa !== 0 && new Date(b.time)) {
        return -1;
      }
      if (a.sisa !== 0 && new Date(a.time) < b.sisa !== 0 && new Date(b.time)) {
        return 1;
      }
      return 0;
    });

  const canManage = hasRole(dataUser, "super_user", "ppic_admin");

  return (
    <div className="container_dashboard krn-page">
      <p className="krn-title">Karantina</p>
      <div className="krn-tabs">
        <p
          className={
            subMenu === "Monitoring" ? "krn-tab krn-tab-active" : "krn-tab"
          }
          onClick={() => setSubMenu("Monitoring")}
        >
          Monitoring
        </p>
        <p
          className={
            subMenu === "Riwayat" ? "krn-tab krn-tab-active" : "krn-tab"
          }
          onClick={() => setSubMenu("Riwayat")}
        >
          Riwayat Pengerjaan
        </p>
        {hasRole(
          dataUser,
          "super_user",
          "qc_admin",
          "qc_user",
          "sp_admin",
          "sp_user",
          "pr_admin",
          "pr_user",
          "pr_checker",
          "ppic_admin"
        ) ? (
          <p
            className={
              subMenu === "Nota" ? "krn-tab krn-tab-active" : "krn-tab"
            }
            onClick={() => setSubMenu("Nota")}
          >
            Buat Nota
          </p>
        ) : (
          ""
        )}
      </div>

      {subMenu === "Nota" ? (
        <>
          {errPopUp ? (
            <PopUpComponent>
              <p>
                <span className="krn-req">&#9888; </span>Mohon Isi Semua Kolom
                Berbintang!
              </p>
              <div className="krn-popup-actions">
                <button
                  className="krn-popup-btn"
                  onClick={() => setErrPopUp(false)}
                >
                  OK
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}
          {popUpKirim ? (
            <PopUpComponent>
              <p>Selamat Nota Karantina Telah dibuat!</p>
              <div className="krn-popup-actions">
                <button
                  className="krn-popup-btn"
                  onClick={() => handleClosePopUp()}
                >
                  OK
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}
          <p className="krn-warning">&#9888; Mohon Isi Sesuai Packing List!</p>
          <div className="krn-form">
            <div className="krn-field">
              <p>
                Pelanggan <span className="krn-req">*</span>
              </p>
              <Select
                options={customer}
                value={customer.find(function (option) {
                  return option.value === pelanggan;
                })}
                onChange={(e) => setPelanggan(e.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Tgl. Produksi <span className="krn-req">*</span>
              </p>
              <input
                className="krn-input"
                type="text"
                placeholder="Contoh: 1/5/24 - 3/5/24"
                value={tanggalProduksi}
                onChange={(e) => setTanggalproduksi(e.target.value)}
              />
            </div>
            <div className="krn-field krn-span-all">
              <p>
                Nama Barang <span className="krn-req">*</span>
              </p>
              <Select
                options={listProduk}
                value={listProduk.find(function (option) {
                  return option.value === produkPick;
                })}
                onChange={setProdukPick}
              />
            </div>
            <div className="krn-field">
              <p>
                Asal Barang <span className="krn-req">*</span>
              </p>
              <Select
                options={asalBarang}
                value={asalBarang.find(function (option) {
                  return option.value === bagian;
                })}
                onChange={(e) => setBagian(e.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Shift <span className="krn-req">*</span>
              </p>
              <input
                className="krn-input"
                type="text"
                placeholder="Contoh: 1/2/3"
                value={shift}
                onChange={(e) => setShift(e.target.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Mesin <span className="krn-req">*</span>
              </p>
              <Select
                options={noMesin}
                value={noMesin.find(function (option) {
                  return option.value === mesin;
                })}
                onChange={(e) => setMesin(e.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Operator <span className="krn-req">*</span>
              </p>
              <input
                className="krn-input"
                type="text"
                placeholder="Contoh: Toni/Dewi/Mei"
                value={operator}
                onChange={(e) => setOperator(e.target.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Isi / Kemasan <span className="krn-req">*</span>
              </p>
              <input
                className="krn-input"
                type="number"
                placeholder="Isi Per Kemasan"
                value={isiPerKemasan}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setIsiPerKemasan(e.target.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Jumlah Kemasan <span className="krn-req">*</span>
              </p>
              <input
                className="krn-input"
                type="text"
                placeholder="Jumlah Kemasan"
                value={jumlahKemasan}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setJumlahKemasan(e.target.value)}
              />
            </div>
            <div className="krn-field">
              <p>
                Jumlah Total <span className="krn-req">*</span>
              </p>
              <input
                className="krn-input"
                type="number"
                placeholder="Jumlah Total"
                value={jumlahTotal}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setJumlahTotal(e.target.value)}
              />
            </div>
            <div className="krn-field krn-span-all">
              <p>
                Keterangan Masalah <span className="krn-req">*</span>
              </p>
              <textarea
                className="krn-textarea"
                onChange={(e) => setKeterangan(e.target.value)}
                name="Keterangan"
                placeholder="Keterangan"
                value={keterangan}
              />
            </div>
          </div>
          <div className="krn-form-actions">
            <button className="krn-btn" onClick={() => handleKirim()}>
              Kirim
            </button>
          </div>
          <br />
        </>
      ) : subMenu === "Riwayat" ? (
        <>
          <div className="krn-filter">
            <div className="krn-field">
              <p>Pilih Bulan</p>
              <select
                className="krn-select"
                value={filterMonth}
                onChange={(e) => setFilterMonth(e.target.value)}
              >
                <option disabled>Pilih Bulan</option>
                {filterMonthConstant.map((data) => (
                  <option value={data.value}>{data.label}</option>
                ))}
              </select>
            </div>
            <div className="krn-field">
              <p>Pilih Tahun</p>
              <select
                className="krn-select"
                value={filterYear}
                onChange={(e) => setFilterYear(e.target.value)}
              >
                <option disabled>Pilih Tahun</option>
                {filterYearConstant.map((data) => (
                  <option value={data.value}>{data.label}</option>
                ))}
              </select>
            </div>
            <div className="krn-field">
              <p>Asal Barang</p>
              <select
                className="krn-select"
                value={filterBagian}
                onChange={(e) => setFilterBagian(e.target.value)}
              >
                <option disabled selected={!filterBagian}>
                  Pilih Asal Barang
                </option>
                {asalBarang.map((data) => (
                  <option value={data.value}>{data.label}</option>
                ))}
              </select>
            </div>
            <div className="krn-field">
              <p>Produk</p>
              <select
                className="krn-select"
                value={filterProduk}
                onChange={(e) => setFilterProduk(e.target.value)}
              >
                <option disabled selected={!filterProduk}>
                  Pilih Produk
                </option>
                {listFilterProduk &&
                  listFilterProduk.map((data) => (
                    <option value={data}>{data}</option>
                  ))}
              </select>
            </div>
            {hasRole(dataUser, "super_user", "ppic_admin", "qc_admin") ? (
              <button
                className="krn-btn-export"
                onClick={() => exportRiwayatPengerjaan()}
              >
                Export
              </button>
            ) : (
              ""
            )}
          </div>
          {popUpEdit ? (
            <PopUpComponent>
              <div className="krn-popup-head">
                <p>
                  <b>Edit Pengerjaan</b>
                </p>
                <img
                  className="krn-close"
                  src={CloseLogo}
                  onClick={() => setPopUpEdit(false)}
                  alt="close_logo"
                />
              </div>
              <div className="krn-popup-fields">
                <div className="krn-field">
                  <p>Pengerjaan (PCS)</p>
                  <input
                    type="number"
                    className="krn-input krn-input-sm"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => setEditPengerjaan(Number(e.target.value))}
                    value={editPengerjaan}
                    placeholder="Jumlah (Pcs)"
                  />
                </div>
                <div className="krn-field">
                  <p>NG (PCS)</p>
                  <input
                    type="number"
                    className="krn-input krn-input-sm"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => setEditNG(Number(e.target.value))}
                    value={editNG}
                    placeholder="Jumlah NG (Pcs)"
                  />
                </div>
                <div className="krn-field">
                  <p>Rework (PCS)</p>
                  <input
                    type="number"
                    className="krn-input krn-input-sm"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setEditJumlahRework(Number(e.target.value))
                    }
                    value={editJumlahRework}
                    placeholder="Jumlah Rework (Pcs)"
                  />
                </div>
              </div>
              <div className="krn-popup-actions">
                <button
                  className="krn-popup-btn"
                  onClick={() => handleKirimEdit()}
                >
                  Edit
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}

          {popUpDelete ? (
            <PopUpComponent>
              <div className="krn-popup-head">
                <p>Apakah Kamu Yakin ingin menghapus riwayat Pengerjaan ini?</p>
                <img
                  className="krn-close"
                  src={CloseLogo}
                  onClick={() => setPopUpDelete(false)}
                  alt="close_logo"
                />
              </div>
              <div className="krn-popup-actions">
                <button
                  className="krn-popup-btn"
                  onClick={() => handleDeletePengerjaan()}
                >
                  Delete
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}
          <div className="krn-table-wrap">
            <table className="krn-table">
              <tr>
                <th className="krn-th">No</th>
                <th className="krn-th">Nota</th>
                <th className="krn-th">Pengerjaan</th>
                <th className="krn-th">Operator</th>
                <th className="krn-th">Produk</th>
                <th className="krn-th">
                  Pengerjaan <br />
                  (PCS)
                </th>
                <th className="krn-th">
                  NG
                  <br />
                  (PCS)
                </th>
                <th className="krn-th">
                  Rework
                  <br />
                  (PCS)
                </th>
                <th className="krn-th">Bagian</th>
                {canManage ? <th className="krn-th">Edit</th> : ""}
                {canManage ? <th className="krn-th">Delete</th> : ""}
              </tr>
              {sortDataRiwayat &&
                sortDataRiwayat.map((e, index) => {
                  return (
                    <tr>
                      <td className="krn-td">{index + 1}</td>
                      <td className="krn-td krn-td-nowrap">
                        {formatDateNota(e.tanggalNota)}
                      </td>
                      <td className="krn-td krn-td-nowrap">
                        {formatDateNota(e.time)}
                      </td>
                      <td className="krn-td">{e.operator}</td>
                      <td className="krn-td krn-td-nowrap">{e.produkPick}</td>
                      <td className="krn-td">
                        {e.jumlahPengerjaan
                          ? formatDot(e.jumlahPengerjaan)
                          : ""}
                      </td>
                      <td className="krn-td">
                        {e.jumlahNG ? formatDot(e.jumlahNG) : ""}
                      </td>
                      <td className="krn-td">
                        {e.jumlahRework ? formatDot(e.jumlahRework) : ""}
                      </td>
                      <td className="krn-td">{e.bagian}</td>
                      {canManage ? (
                        <td className="krn-td">
                          <img
                            className="krn-icon krn-icon-edit"
                            src={EditLogo}
                            onClick={() => pickEdit(e)}
                            alt="edit_logo"
                          />
                        </td>
                      ) : (
                        ""
                      )}
                      {canManage ? (
                        <td className="krn-td">
                          <img
                            className="krn-icon krn-icon-delete"
                            src={DeleteIcon}
                            alt="delete-icon"
                            onClick={() => pickEditDelete(e)}
                          />
                        </td>
                      ) : (
                        ""
                      )}
                    </tr>
                  );
                })}
            </table>
          </div>
          <br />
        </>
      ) : (
        <>
          <div className="krn-filter">
            <div className="krn-field">
              <p>Pilih Bulan</p>
              <select
                className="krn-select"
                value={filterMonth}
                onChange={(e) => setFilterMonth(Number(e.target.value))}
              >
                <option disabled>Pilih Bulan</option>
                {filterMonthConstant.map((data) => (
                  <option value={data.value}>{data.label}</option>
                ))}
              </select>
            </div>
            <div className="krn-field">
              <p>Pilih Tahun</p>
              <select
                className="krn-select"
                value={filterYear}
                onChange={(e) => setFilterYear(Number(e.target.value))}
              >
                <option disabled>Pilih Tahun</option>
                {filterYearConstant.map((data) => (
                  <option value={data.value}>{data.label}</option>
                ))}
              </select>
            </div>
            <div className="krn-field">
              <p>Pilih Asal Barang</p>
              <select
                className="krn-select"
                value={filterBagian}
                onChange={(e) => setFilterBagian(e.target.value)}
              >
                <option disabled selected={!filterBagian}>
                  Pilih Asal Barang
                </option>
                {asalBarang.map((data) => (
                  <option value={data.value}>{data.label}</option>
                ))}
              </select>
            </div>
          </div>
          <p className="krn-warning">
            &#9888; Klik Pada Bagian Kuning Kartu Nota!
          </p>
          {popUpSuccess ? (
            <PopUpComponent>
              <p>Cek Riwayat Pengerjaan!</p>
              <div className="krn-popup-actions">
                <button
                  className="krn-popup-btn"
                  onClick={() => setPopUpSuccess(false)}
                >
                  OK
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}
          {popUpPengerjaan ? (
            <PopUpComponent>
              <div className="krn-popup-head">
                <p>
                  <b>Nota:</b>
                  <br />
                  {formatDateNota(produkPopUp.tanggalNota)}
                </p>
                <img
                  className="krn-close"
                  src={CloseLogo}
                  onClick={() => setPopUpPengerjaan(false)}
                  alt="close_logo"
                />
              </div>
              <p>
                <b>{produkPopUp.produkPick}</b>
              </p>

              <div className="krn-popup-fields">
                <div className="krn-field">
                  <p>Pengerjaan (PCS)</p>
                  <input
                    type="number"
                    className="krn-input krn-input-sm"
                    onWheel={(e) => e.target.blur()}
                    value={jumlahPengerjaan}
                    onChange={(e) => setJumlahPengerjaan(e.target.value)}
                    placeholder="Jumlah (Pcs)"
                  />
                </div>
                <div className="krn-field">
                  <p>NG (PCS)</p>
                  <input
                    value={jumlahNG}
                    type="number"
                    className="krn-input krn-input-sm"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => setJumlahNG(e.target.value)}
                    placeholder="Jumlah NG (Pcs)"
                  />
                </div>
                <div className="krn-field">
                  <p>Rework (PCS)</p>
                  <input
                    type="number"
                    className="krn-input krn-input-sm"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => setJumlahRework(Number(e.target.value))}
                    value={jumlahRework}
                    placeholder="Jumlah Rework (Pcs)"
                  />
                </div>
              </div>
              <div className="krn-popup-actions">
                <button
                  className="krn-popup-btn"
                  onClick={() => handleKirimPengerjaan()}
                >
                  Kirim
                </button>
              </div>
            </PopUpComponent>
          ) : (
            ""
          )}
          <div className="krn-card-list">
            {aggregateSortiran &&
              aggregateSortiran.map((data) => {
                return (
                  <div
                    className={
                      data.sisa > 0 ? "krn-card krn-card-open" : "krn-card"
                    }
                    onClick={() =>
                      data.sisa > 0 &&
                      !hasRole(dataUser, "super_user", "ppic_admin")
                        ? handlePickNota(data.id)
                        : ""
                    }
                  >
                    <div className="krn-card-cols">
                      <div className="krn-card-col">
                        <div className="krn-line">
                          <b>Tanggal Nota :</b>
                          {formatDateNota(data.tanggalNota)}
                        </div>
                        <div className="krn-line">
                          <b>Nama Barang :</b>
                          {data.produkPick}
                        </div>
                        <div className="krn-line">
                          <b>Warna :</b>
                          {data.warna}
                        </div>
                        <div className="krn-line">
                          <b>Pelanggan :</b> PT. {data.pelanggan}
                        </div>
                        <div className="krn-line">
                          <b>TGL. Produksi :</b>
                          {data.tanggalProduksi}
                        </div>
                        <div
                          className={
                            data.sisa > 0
                              ? "krn-line krn-line-warn"
                              : "krn-line"
                          }
                        >
                          <b>Sisa Sortiran :</b>
                          {formatDot(data.sisa)} Pcs
                        </div>
                      </div>
                      <div className="krn-card-col">
                        <div className="krn-line">
                          <b>Shift/Mesin :</b>
                          {data.shift} / {data.mesin}
                        </div>
                        <div className="krn-line">
                          <b>Operator :</b> {data.operator}
                        </div>
                        <div className="krn-line">
                          <b>Isi/Kemasan :</b>
                          {formatDot(data.isiPerKemasan)} Pcs
                        </div>
                        {isEditNota ? (
                          <div className="krn-line">
                            <b>Jumlah Kemasan :</b>
                            <input
                              className="krn-input"
                              type="text"
                              placeholder="Isi Per Kemasan"
                              value={jumlahKemasanEdit}
                              onChange={(e) =>
                                setJumlahKemasanEdit(e.target.value)
                              }
                            />
                          </div>
                        ) : (
                          <div className="krn-line">
                            <b>Jumlah Kemasan :</b>
                            {formatDot(data.jumlahKemasan)}
                          </div>
                        )}
                        {isEditNota ? (
                          <div className="krn-line">
                            <b>Jumlah Total :</b>
                            <input
                              className="krn-input"
                              type="number"
                              placeholder="Jumlah Total"
                              value={jumlahTotalEdit}
                              onChange={(e) =>
                                setJumlahTotalEdit(e.target.value)
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        ) : (
                          <div className="krn-line">
                            <b>Jumlah Total :</b>
                            {formatDot(data.jumlahTotal)} Pcs
                          </div>
                        )}
                      </div>
                      {canManage ? (
                        <div className="krn-card-side">
                          <img
                            className="krn-icon krn-icon-edit krn-icon-lg"
                            src={EditLogo}
                            onClick={() => setIsEditNota(true)}
                            alt="edit_logo"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <p className="krn-note-label">Keterangan :</p>
                    <p className="krn-note">{data.keterangan}</p>
                    {isEditNota ? (
                      <div className="krn-card-footer">
                        <button
                          className="krn-popup-btn"
                          onClick={() => handleKirimEditNota(data)}
                        >
                          Kirim
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
};

export default Karantina;
